var $ = jQuery.noConflict();
var EMERSON = EMERSON || {};
(function($) {
    "use strict";
    EMERSON.initialize = {
        init: function(){
            EMERSON.initialize.responsiveClasses();
            EMERSON.initialize.tabWidget();
        },
        responsiveClasses: function(){

            if( typeof jRespond === 'undefined' ) {
                console.log('responsiveClasses: jRespond not Defined.');
                return true;
            }

            var jRes = jRespond([
                {
                    label: 'smallest',
                    enter: 0,
                    exit: 575
                },{
                    label: 'handheld',
                    enter: 576,
                    exit: 767
                },{
                    label: 'tablet',
                    enter: 768,
                    exit: 991
                },{
                    label: 'laptop',
                    enter: 992,
                    exit: 1199
                },{
                    label: 'desktop',
                    enter: 1200,
                    exit: 10000
                }
            ]);
            jRes.addFunc([
                {
                    breakpoint: 'desktop',
                    enter: function() { $body.addClass('device-xl'); },
                    exit: function() { $body.removeClass('device-xl'); }
                },{
                    breakpoint: 'laptop',
                    enter: function() { $body.addClass('device-lg'); },
                    exit: function() { $body.removeClass('device-lg'); }
                },{
                    breakpoint: 'tablet',
                    enter: function() { $body.addClass('device-md'); },
                    exit: function() { $body.removeClass('device-md'); }
                },{
                    breakpoint: 'handheld',
                    enter: function() { $body.addClass('device-sm'); },
                    exit: function() { $body.removeClass('device-sm'); }
                },{
                    breakpoint: 'smallest',
                    enter: function() { $body.addClass('device-xs'); },
                    exit: function() { $body.removeClass('device-xs'); }
                }
            ]);
        },
        tabWidget: function(){
            if( !$().tabs ) {
                console.log('tabs: Tabs not Defined.');
                return true;
            }

            var $tabs = $('.tabs');
            if( $tabs.length > 0 ) {
                $tabs.each( function(){
                    var element = $(this),
                        elementSpeed = element.attr('data-speed'),
                        tabActive = element.attr('data-active');

                    if( !elementSpeed ) { elementSpeed = 400; }
                    if( !tabActive ) { tabActive = 0; } else { tabActive = tabActive - 1; }

                    var windowHash = window.location.hash;
                    if( jQuery(windowHash).length > 0 ) {
                        var windowHashText = windowHash.split('#'),
                            tabItem = document.getElementById( windowHashText[1] );
                        tabActive = jQuery( ".tab-content" ).index( tabItem );
                    }

                    element.tabs({
                        active: Number(tabActive),
                        show: {
                            effect: "fade",
                            duration: Number(elementSpeed)
                        }
                    });
                    element.find('.tab-linker').each( function(){
                        var linker = $(this);
                        linker.click(function() {
                            element.tabs("option", "active", $(this).attr('rel') - 1);
                            return false;
                        });
                    });
                });
            }
        }
    };
    EMERSON.header = {
        init: function(){
            //EMERSON.header.superfish();
            EMERSON.header.menuFunction();
            //EMERSON.header.stickyMenu();
        },
        // superfish: function(){
        //     if( $body.hasClass('device-xl') || $body.hasClass('device-lg') ) {
        //         $('#primary-menu-top ul ul').css('display', 'block');
        //         $('#primary-menu-top ul ul').css('display', '');

        //         if( !$().superfish ) {
        //             $body.addClass('no-superfish');
        //             console.log('superfish: Superfish not Defined.');
        //             return true;
        //         }

        //         $('#primary-menu-top > ul').superfish({
        //             popUpSelector: 'ul',
        //             delay: 250,
        //             speed: 350,
        //             animation: {opacity:'show'},
        //             animationOut:  {opacity:'hide'},
        //             cssArrows: false,
        //             onShow: function(){}
        //         });
        //     }
        // },
        // stickyMenu: function( headerOffset ){
        //     if ($window.scrollTop() > headerOffset) {
        //         if( $body.hasClass('device-xl') || $body.hasClass('device-lg') ) {
        //             $('#header:not(.no-sticky)').addClass('sticky-header');
        //         }
        //     }else {
        //         EMERSON.header.removeStickyness();
        //     }
        // },
        // removeStickyness: function(){
        //     if( $header.hasClass('sticky-header') ){
        //         $('body:not(.side-header) #header:not(.no-sticky)').removeClass('sticky-header');
        //         $header.removeClass().addClass(oldHeaderClasses);
        //         $headerWrap.removeClass().addClass(oldHeaderWrapClasses);
        //     }
        //     if( $body.hasClass('device-sm') || $body.hasClass('device-xs') || $body.hasClass('device-md') ) {
        //         $header.removeClass().addClass(oldHeaderClasses);
        //         $headerWrap.removeClass().addClass(oldHeaderWrapClasses);
        //     }
        // },
        menuFunction: function(){
            $( '#primary-menu ul li:has(ul)' ).addClass('sub-menu');
            if( $('#primary-menu').hasClass('on-click') || ( $body.hasClass('device-md') || $body.hasClass('device-sm') || $body.hasClass('device-xs') ) ) {
                $('#primary-menu li:has(ul) > a').on( 'click touchend', function(e){
                    var telem = $(this).parent('.sub-menu').siblings().find('ul');
                    if(telem.length) {
                        telem.slideUp('');
                    }
                    $(this).parent('li').children('ul').slideToggle();
                    $(this).toggleClass('opened');
                    e.preventDefault();
                });
            }
        },
    };
    EMERSON.isMobile = {
        Android: function() {
            return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function() {
            return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function() {
            return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function() {
            return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function() {
            return navigator.userAgent.match(/IEMobile/i);
        },
        any: function() {
            return (EMERSON.isMobile.Android() || EMERSON.isMobile.BlackBerry() || EMERSON.isMobile.iOS() || EMERSON.isMobile.Opera() || EMERSON.isMobile.Windows());
        }
    };
    EMERSON.documentOnReady = {
        init: function(){
            EMERSON.initialize.init();
            windowWidth = $window.width();
            EMERSON.header.init();
            //EMERSON.documentOnReady.windowscroll();
            EMERSON.documentOnReady.animations();
            EMERSON.documentOnReady.accordions();
            EMERSON.documentOnReady.jsSlider();
            $('#primary-menu-trigger').off( 'click' ).on( 'click', function() {
                $body.addClass("primary-menu-open");
                $html.addClass('no-scroll');
                $body.removeClass("primary-menu-hidden");
                return false;
            });
            $('#primary-menu-close, .menu-overlay').off( 'click' ).on( 'click', function() {
                $body.addClass("primary-menu-hidden");
                $html.removeClass('no-scroll');
                setTimeout(function(){
                    $body.removeClass("primary-menu-open");
                }, 200);
                return false;
            });
            $('.video-controls').each(function(){
                $(this).on('click', function(){
                    let $video = $(this).parent().find('video');
                    if ($video.get(0).paused || $video.get(0).ended) {
                        $video.get(0).play();
                        $(this).parent().addClass('playing');
                    } else {
                        $video.get(0).pause();
                        $(this).parent().removeClass('playing');
                    }
                });
            });
            $('.video-container video').each(function(){
                $(this).on('pause', function(){
                    if($(this).get(0).paused) {
                        $(this).parent().removeClass('playing');
                    }
                })
            });
            if($('.media-gallery').length) {
                $('.media-gallery').magnificPopup({
                    delegate: '.gallery-img',
                    type: 'image',
                    fixedContentPos: true,
                    closeOnBgClick: true,
                    alignTop: false,
                    tLoading: 'Loading image #%curr%...',
                    mainClass: 'mfp-img-mobile',
                    gallery: {
                        enabled: true,
                        navigateByImgClick: true,
                        preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
                    }
                });
            }
            if($('.quotes').length) {
                $('.quotes').magnificPopup({
                    delegate: '.quote-modal-trigger',
                    type: 'inline',
                    preloader: false,
                    modal: true,
                    gallery: {
                        enabled: true,
                        preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
                    }
                });
                $(document).on('click', '.quote-modal-dismiss', function (e) {
                    e.preventDefault();
                    $.magnificPopup.close();
                });
            }

            if($('#single-content').length) {
                EMERSON.documentOnReady.scrollProgress();
                window.addEventListener('scroll', function(e) {
                    EMERSON.documentOnReady.scrollProgress();
                });
            }
            // if( $('#primary-menu-top').hasClass('on-click') || ( $body.hasClass('device-md') || $body.hasClass('device-sm') || $body.hasClass('device-xs') ) ) {
            //     $('#primary-menu-top li:has(ul) > a').on( 'click touchend', function(e){
            //         $(this).parents('.sub-menu').siblings().find('ul').removeClass('d-block');
            //         $(this).parent('li').children('ul').slideToggle();
            //         $(this).toggleClass('opened');
            //         e.preventDefault();
            //     });
            // }
            EMERSON.documentOnReady.readMore();
            $('.search-trigger').click(function () {
                $(this).toggleClass('opened');
                $(this).parent().find('.search-form').toggleClass('show');
            });
            $( '.posts-ordering' ).on( 'change', 'select', function() {
                $( this ).closest( 'form' ).find('#order').val($(this).val());
                $( this ).closest( 'form' ).submit();
            });
        },
        readMore: function(){
            if($('.staff-info').length && ( $body.hasClass('device-xl') || $body.hasClass('device-lg'))) {
                $('.staff-info .summary').each(function(elem){
                    if($(this).height() > 235) {
                        $(this).addClass('text-overflow');
                        $(this).find('.read-more').click(function(event){
                            event.preventDefault();
                            $(this).parent().toggleClass('open');
                            $(this).toggleClass('show-all');
                        });
                    }
                });
            }
        },
        scrollProgress: function() {
            const cw = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            const minwidth = cw / 2 - $('#single-content').width() / 2 + 50;
            let scrolltop = $window.scrollTop() + $('#header-wrap').height();
            if($('body').hasClass('admin-bar')) {
                scrolltop = scrolltop + $('#wpadminbar').height();
            }
            if (scrolltop > $('#single-content').offset().top) {
                $('#scroll-progress').addClass('fixed');
            } else {
                $('#scroll-progress').removeClass('fixed');
            }
            //let w = (document.body.scrollTop || document.documentElement.scrollTop) / (document.documentElement.scrollHeight - document.documentElement.clientHeight - $('#footer').height()) * 100;
            let w = window.scrollY / (document.getElementById('single-content').offsetHeight - window.innerHeight);
            let wp = w > 1 ? w = 100 : Math.round(w * 100);
            if((cw * wp / 100) >= minwidth) {
                $('#scroll-progress').css('width', wp + '%');
            }else {
                $('#scroll-progress').css('width', minwidth + 'px');
            }
        },
        jsSlider: function(){
            $('.js-slider').each(function(){
                var element = $(this);
                var options = $(this).data('slick');
                options = $.extend(options, {
                		dots: true,
                    responsive: [
                        {
                            breakpoint: 1470,
                            settings: {
                                slidesToShow: $(this).data('show-lg') ? $(this).data('show-lg') : 1,
                                slidesToScroll: 1,
                                dots: true
                            }
                        },
                        {
                            breakpoint: 992,
                            settings: {
                                slidesToShow: $(this).data('show-md') ? $(this).data('show-md') : 1,
                                slidesToScroll: 1,
                                arrows: false,
                                dots: true
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: $(this).data('show-sm') ? $(this).data('show-sm') : 1,
                                slidesToScroll: 1,
                                arrows: false,
                                dots: true
                            }
                        },
                        {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: $(this).data('show-xs') ? $(this).data('show-xs') : 1,
                                slidesToScroll: 1,
                                arrows: false,
                                dots: true
                            }
                        }
                    ]
                });
                element.slick(options);
            });
        },
        // windowscroll: function(){
        //     var headerWrapOffset = 0;
        //     if( $header.length > 0 ) { headerWrapOffset = $headerWrap.offset().top; }

        //     EMERSON.header.stickyMenu( headerWrapOffset );

        //     $window.on( 'scroll', function(){
        //         EMERSON.header.stickyMenu( headerWrapOffset );
        //     });
        // },
        animations: function(){

            if( !$().appear ) {
                console.log('animations: Appear not Defined.');
                return true;
            }

            var $dataAnimateEl = $('[data-animate]');
            if( $dataAnimateEl.length > 0 ){
                if( $body.hasClass('device-xl') || $body.hasClass('device-lg') || $body.hasClass('device-md') ){
                    $dataAnimateEl.each(function(){
                        var element = $(this),
                            animationOut = element.attr('data-animate-out'),
                            animationDelay = element.attr('data-delay'),
                            animationDelayOut = element.attr('data-delay-out'),
                            animationDelayTime = 0,
                            animationDelayOutTime = 3000;

                        if( animationDelay ) { animationDelayTime = Number( animationDelay ) + 500; } else { animationDelayTime = 500; }
                        if( animationOut && animationDelayOut ) { animationDelayOutTime = Number( animationDelayOut ) + animationDelayTime; }

                        if( !element.hasClass('animated') ) {
                            element.addClass('not-animated');
                            var elementAnimation = element.attr('data-animate');
                            element.appear(function () {
                                setTimeout(function() {
                                    element.removeClass('not-animated').addClass( elementAnimation + ' animated');
                                }, animationDelayTime);

                                if( animationOut ) {
                                    setTimeout( function() {
                                        element.removeClass( elementAnimation ).addClass( animationOut );
                                    }, animationDelayOutTime );
                                }
                            },{accX: 0, accY: -120},'easeInCubic');
                        }
                    });
                }
            }
        },
        topScrollOffset: function() {
            var topOffsetScroll = 0;

            if( ( $body.hasClass('device-xl') || $body.hasClass('device-lg') ) && !EMERSON.isMobile.any() ) {
                if( $header.hasClass('sticky-header') ) { topOffsetScroll = 100; } else { topOffsetScroll = 140; }
            } else {
                topOffsetScroll = 40;
            }

            return topOffsetScroll;
        },
        accordions: function(){
            var $accordionEl = $('.accordion');
            if( $accordionEl.length > 0 ){
                $accordionEl.each( function(){
                    var element = $(this),
                        elementState = element.attr('data-state'),
                        accordionActive = element.attr('data-active');

                    if( !accordionActive ) { accordionActive = 0; } else { accordionActive = accordionActive - 1; }

                    element.find('.acc_content').hide();

                    if( elementState != 'closed' ) {
                        element.find('.acctitle:eq('+ Number(accordionActive) +')').addClass('active').next().show();
                    }

                    element.find('.acctitle').off( 'click' ).on( 'click', function(){
                        if( $(this).next().is(':hidden') ) {
                            element.find('.acctitle').removeClass('active').next().slideUp("normal");
                            var clickTarget = $(this);
                            $(this).toggleClass('active').next().stop().slideDown("normal", function(){
                                if( ( $body.hasClass('device-sm') || $body.hasClass('device-xs') ) && element.hasClass('scroll-on-open') ) {
                                    $('html,body').stop(true).animate({
                                        'scrollTop': clickTarget.offset().top - ( EMERSON.documentOnReady.topScrollOffset() - 40 )
                                    }, 500, 'easeOutQuad' );
                                }
                            });
                        }
                        return false;
                    });
                });
            }
        },
    };
    EMERSON.documentOnLoad = {
        init: function(){
        }
    };
    EMERSON.documentOnResize = {
        init: function(){
            windowWidth = $window.width();
            if( EMERSON.isMobile.any() ){
                $body.addClass('device-touch');
            }
            if($('#single-content').length) {
                EMERSON.documentOnReady.scrollProgress();
            }
            EMERSON.documentOnReady.readMore();
        }
    };
    var $window = $(window),
        $header = $('#header'),
        $headerWrap = $('#header-wrap'),
        oldHeaderClasses = $header.attr('class'),
        oldHeaderWrapClasses = $headerWrap.attr('class'),
        $body = $('body'),
        $html = $('html'),
        windowWidth;

    $(document).ready( EMERSON.documentOnReady.init );
    $window.on( 'load', EMERSON.documentOnLoad.init );
    $window.on( 'resize', EMERSON.documentOnResize.init );

		var distance = $('#header').offset().top; 
		$(window).scroll(function () {
			if ($(window).scrollTop() >= distance) {
				$('#header').addClass("sticky-header");
			} else {
				$('#header').removeClass("sticky-header");
			}
		});    
})(jQuery);
